"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteFolderModalCurrentFolderId = exports.deleteFolderModalVisibleState = void 0;
const react_1 = __importStar(require("react"));
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const folder_1 = require("../../../server/models/folder");
const FoldersRoute_1 = __importDefault(require("../../../routes/FoldersRoute"));
const DeleteModal_1 = __importDefault(require("../Modals/DeleteModal"));
const RedirectTo_1 = __importDefault(require("../../../utilities/RedirectTo"));
const react_router_dom_1 = require("react-router-dom");
const useCurrentFolder_1 = __importDefault(require("../FoldersPage/useCurrentFolder"));
exports.deleteFolderModalVisibleState = (0, recoil_1.atom)({
    key: 'deleteFolderModalVisibleState',
    default: false,
});
exports.deleteFolderModalCurrentFolderId = (0, recoil_1.atom)({
    key: 'deleteFolderModalCurrentFolderId',
    default: -1,
});
const DeleteFolderModal = ({ t }) => {
    const [visible, setVisible] = (0, recoil_1.useRecoilState)(exports.deleteFolderModalVisibleState);
    const [folderId] = (0, recoil_1.useRecoilState)(exports.deleteFolderModalCurrentFolderId);
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [, setErrorState] = (0, react_1.useState)({ hasError: false, redirectUrl: '' });
    const handleErrors = (err) => {
        if (err.response.status === 404) {
            setErrorState({ hasError: true, redirectUrl: '/notfound' });
        }
        else {
            setErrorState({ hasError: true, redirectUrl: '/error' });
        }
    };
    const [isFetchingFolder, currentFolder, folders, dashboards, looks] = (0, useCurrentFolder_1.default)({
        folderId: folderId,
        handleErrorsCallback: handleErrors,
    });
    const successCallback = () => {
        if (location.pathname
            .toLowerCase()
            .includes(FoldersRoute_1.default.path.toLowerCase()))
            (0, RedirectTo_1.default)({
                history,
                path: `${FoldersRoute_1.default.path}/${currentFolder?.parentId}`,
            });
    };
    const deleteModalProps = {
        formSubmitCallback: async () => await (0, folder_1.deleteFolder)(currentFolder?.id || -1),
        successCallback: successCallback,
        successMessage: t('folderDeleteSuccess'),
        failureMessage: t('folderDeleteFail'),
        errorMessage: t('folderDeleteError'),
        typeOfItemToDelete: 'Folder',
        headerText: `${t('folderDeleteHeader')} “${currentFolder?.name}”`,
        primaryButtonText: t('folderDeleteButton'),
        autoFocus: true,
        t: t,
        visible: visible,
        setVisible: (isVisible) => setVisible(isVisible),
        folderCount: folders.length,
        dashboardCount: dashboards.length,
        lookCount: looks.length,
        loading: isFetchingFolder,
    };
    return react_1.default.createElement(DeleteModal_1.default, { ...deleteModalProps });
};
exports.default = (0, react_i18next_1.withTranslation)('ModalWindow')(DeleteFolderModal);
